/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import { Fade, Paper, Popper } from '@material-ui/core'
import type { PopperPlacementType } from '@material-ui/core'
import useStyles from './useStyles'

type PopperComponentProps = React.ComponentProps<typeof Popper>

interface ContextMenuProps {
  open: boolean
  anchorEl?: PopperComponentProps['anchorEl']
  placement?: PopperPlacementType
  onClose?: () => void
  children: React.ReactElement
  offsetX?: number | string
  offsetY?: number | string
}

const ContextMenu: React.FunctionComponent<ContextMenuProps> = (props) => {
  const { anchorEl, children, open, placement: placementProp = 'bottom-start', offsetX = 0, offsetY = 0, onClose } = props
  const openRef = React.useRef(open)
  const classes = useStyles()

  React.useEffect(() => {
    const onKeydown = (e: WindowEventMap['keydown']) => {
      if (!openRef.current) return
      if (e.key === 'Escape') {
        onClose?.()
      }
    }
    window.addEventListener('keydown', onKeydown)

    return () => {
      window.removeEventListener('keydown', onKeydown)
    }
  }, [openRef])

  React.useEffect(() => {
    openRef.current = open
  }, [open])

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placementProp}
      modifiers={{
        offset: {
          offset: `${offsetX},${offsetY}`,
        },
      }}
      className={classes.popper}
      style={{ zIndex: 99999 }}
      transition
    >
      {({ TransitionProps, placement }) => (
        <Fade
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
          }}
        >
          <Paper>{children}</Paper>
        </Fade>
      )}
    </Popper>
  )
}

export default ContextMenu
